import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'
export const getUserProfileData = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getUserProfile)
		const data = responseJson.data.data
		return data // Ret
	} catch (error) {
		throw error
	}
}

export const updateUserProfileDataThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.editUserProfile, body)
		return responseJson
	} catch (error) {
		throw error
	}
}
// KYC DATA
export const getKYCDataThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getKycDetailsOfUser)
		const data = responseJson.data.data
		return data // Ret
	} catch (error) {
		throw error
	}
}

export const updateUserKycDataThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.addAndUpdateKycDetails, body)
		return responseJson
	} catch (error) {
		throw error
	}
}

// KYC DATA
export const getBankDetailsThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getBankDetailsOfUser)
		const data = responseJson.data.data
		return data // Ret
	} catch (error) {
		throw error
	}
}

export const updateBankDetailsThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.addAndUpdateBankDetails, body)
		return responseJson
	} catch (error) {
		throw error
	}
}

export const changePasswordThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.changePassword, body)
		return responseJson
	} catch (error) {
		throw error
	}
}

export const changeTransactionPasswordRequestThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.changeTransactionPasswordRequest, body)
		return responseJson
	} catch (error) {
		throw error
	}
}

export const changeTransactionPasswordThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.changeTransactionPassword, body)
		return responseJson
	} catch (error) {
		throw error
	}
}
